import get from 'lodash/get';

// 私有化License状态
export enum LicenseStatus {
    Valid = 0,
    UnAuthed = 1, // 未被授权
    Expired = 2, // 过期
}

export const isLicenseValid = (): boolean => {
    const licenseStatus = get(window.clientVars, 'license_status') || LicenseStatus.Valid;
    return licenseStatus !== LicenseStatus.UnAuthed && licenseStatus !== LicenseStatus.Expired;
};
